<div class="login-bg">
	<div class="login-page">
  <div class="login-form">
    
    	<form [formGroup]="formGroup" (ngSubmit)="reset()" class="form-container">
				<div class="title">
              <span>
                Terlupa kata laluan?
              </span>

            </div>

					<div class="subheading">Masukkan e-mel yang didaftarkan dengan akaun anda dan kami akan menghantar arahan untuk tetapan semula kata laluan anda.</div>
						<div class="input-container">		
							<mat-form-field appearance="outline">
								<mat-label>Emel</mat-label>
								<input
									matInput
									required
									class="bold-input"
									formControlName="email"
									autocomplete="email"
								/>
								<mat-error>{{ "error.emailRequired" | translate }}</mat-error>
							</mat-form-field>
				
							<button
								mat-raised-button
								class="login-btn"
								[disabled]="formGroup.invalid"
								(click)="goToLogin()"
							>
								Tetap semula kata laluan
							</button>			
						</div>
					
					</form>
  </div>
	<div class="crm-info">
			<img
				src="https://storage.googleapis.com/ps-asset/affiliate/landing/kopetro-banner_1-en.png"
				alt="mockup-1"
				style="width:100%"
			/>
		</div>
</div>

</div>
